import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Activité",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Planning",
      icon: "rdv",
      id: "planning",
      component: "",
      path: "/activite/planning/calendar",
      onClick: "",
      service: SERVICES.Planification,
      roles: [1, 2, 3, 4]
    },

    {
      label: "Questionnaires",
      icon: "survey",
      id: "questionnaire",
      component: "",
      path: "/survey",
      onClick: "",
      service: SERVICES.Formulaire,
      roles: [1, 2, 3, 4],
      submenu: [
        {
          id: "surveyList",
          label: "Liste des questionnaires",
          active: false,
          path: "/survey"
        },
        {
          id: "surveyCreate",
          label: "Créer un questionnaire",
          active: false,
          path: "/survey/creation"
        }
      ]
    },
    {
      label: "Visites",
      icon: "visits",
      id: "visits",
      component: "",
      path: "/visit",
      onClick: "",
      service: SERVICES.Visites,
      submenu: false
    },
    {
      label: "Galerie photos",
      icon: "picture",
      id: "phototheque",
      component: "",
      path: "/phototheque",
      onClick: "",
      service: SERVICES.Phototeque,
      submenu: false
    },
    {
      label: "KPIs",
      icon: "picture",
      id: "kpis",
      component: "",
      path: "/activite/kpis",
      onClick: "",
      roles: [2, 3],
      submenu: false
    },
    {
      label: "Référentiel",
      icon: "ref",
      id: "referential",
      component: "",
      path: "/ref",
      onClick: "",
      roles: [1, 2, 3],
      submenu: false
    },
    {
      label: "Mobile",
      icon: "ref",
      id: "mobile",
      component: "",
      path: "/mobile",
      onClick: "",
      roles: [1, 2, 3, 4],
      submenu: false
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/activite/Menu.js